import { Button } from 'primereact/button'
import { AnyAction } from '@reduxjs/toolkit'
import { useNavigate } from 'react-router-dom'
import React, { Dispatch, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchEndScreenRequest,
  fetchGameLocalesRequest,
} from '../../../redux/actions/gameActions'
import * as DOMPurify from 'dompurify'
import { getGameSelector } from './../../../redux/selectors/gameSelectors'
import { GameState } from '../../../redux/types/game'
import clickSoundEffect from '../../../assets/audio/click2.wav'
import Loading from '../../../components/Loading'
import { AlignBottom, Game } from 'iconsax-react'
import useSound from 'use-sound'
import { useTranslation } from 'react-i18next'
import { decodeIframeString } from '../../../utils/decodeIframeString'

const End = () => {
  const {
    data: { endScreen, volumeGlobal, selectedLanguage, gameLocales, branding },
    loading: gameLoading,
  }: GameState = useSelector(getGameSelector)
  const navigate = useNavigate()
  const dispatch: Dispatch<AnyAction> = useDispatch()
  const [clickSound] = useSound(clickSoundEffect, {
    volume: volumeGlobal,
  })
  const { t } = useTranslation()

  useEffect(() => {
    if (selectedLanguage) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      dispatch(fetchEndScreenRequest(selectedLanguage.id))
    }
  }, [selectedLanguage])

  const sanitizedData = (data: string) => ({
    __html: DOMPurify.sanitize(data, {
      ADD_TAGS: ['iframe'],
      ADD_ATTR: ['src', 'class', 'allowfullscreen', 'frameborder'],
    }),
  })

  if (gameLoading.isLoadingEndScreen || !endScreen) {
    return <Loading />
  }

  return (
    <>
      <div className="p-3 text-center flex flex-column align-items-center ">
        <div
          className="mt-3 img-full-width ql-editor"
          style={{ overflowWrap: 'break-word' }}
          dangerouslySetInnerHTML={sanitizedData(
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            decodeIframeString(endScreen?.html ?? '') ?? '',
          )}
        />

        <Button
          label={t('GoToLeaderboard')}
          onClick={() => {
            clickSound()
            navigate('/leaderboard?showRateAndSocial=true')
          }}
          type="button"
          // icon={<AlignBottom color="#fff" variant="Bold" className="mr-1" />}
          icon={
            <>
              <div
                className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                style={{
                  backgroundColor: branding?.buttonPrimary.textColor,
                }}
              >
                {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
              </div>
              <AlignBottom
                color={branding?.buttonPrimary.backgroundColor}
                variant="Bold"
                className="icon-center"
                // className="p-button-icon p-c p-button-icon-right"
              />
            </>
          }
          className="p-button-rounded mt-5 p-button-raised w-full uppercase"
          style={{
            backgroundColor: branding?.buttonPrimary.backgroundColor,
            color: branding?.buttonPrimary.textColor,
          }}
          // className="p-button-rounded mt-5 p-button-raised w-full sign-in-btn"
        />
      </div>
    </>
  )
}

export default End
